var _path, _rect, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarEmpty = function SvgStarEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h25v24H0z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1672,
    height: 2290,
    x: -1256,
    y: -260,
    rx: 8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-224-180h560v594h-560z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m15.748 8.55-2.569-4.864-.675-1.286-.679 1.286L9.257 8.55l-5.415.937-1.433.248 1.013 1.043 3.832 3.94-.784 5.442-.206 1.44 1.305-.641 4.935-2.427 4.935 2.427 1.301.641-.206-1.44-.784-5.441 3.833-3.941 1.012-1.043-1.432-.248zm4.402 1.98-3.258 3.353-.413.423.083.585.667 4.632-4.196-2.063-.529-.259-.529.259-4.2 2.059.668-4.631.082-.585-.412-.424-3.259-3.349 4.609-.799.581-.101.274-.521 2.186-4.137 2.183 4.137.273.521.582.101z"
  })));
};
export default SvgStarEmpty;